import { Box, Button, Dialog, Grid, TextField, Typography, useMediaQuery, useTheme } from "@mui/material";
import { TEXT_TITLE_COLOR } from "../../constants/colors";
import AddIcon from '@mui/icons-material/Add';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';

interface Props {
    onClose: VoidFunction;
    title: string;
    code: string;
    imageUrl: string;
    nameEn: string;
    nameLa: string;
}

const ViewDataForm = ({ onClose, title, code, imageUrl, nameEn, nameLa }: Props) => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <Dialog
            fullWidth
            maxWidth={'lg'}
            open={true}
        >
            <Box sx={{ p: isSmallScreen ? 2 : 6 }}>
                <Box mb={isSmallScreen ? 1 : 2}>
                    <Typography variant="h4" color={TEXT_TITLE_COLOR} fontWeight='bold'>
                        {title}
                    </Typography>
                </Box>
                <Grid container spacing={isSmallScreen ? 1 : 2}>
                    <Grid item xs={12} sm={6}>
                        <Box
                            sx={{
                                p: isSmallScreen ? 2 : 4,
                                boxShadow: '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                            }}
                        >
                            <Box sx={{ width: '100%', mt: isSmallScreen ? 1 : 2 }}>
                                <Box>
                                    <Typography>MG CODE</Typography>
                                    <TextField InputProps={{ readOnly: true }} fullWidth size="small" margin="normal" value={code} required placeholder='Enter Main Category Code' />
                                </Box>
                            </Box>
                            <Box sx={{ width: '100%', mt: isSmallScreen ? 1 : 2 }}>
                                <Box>
                                    <Typography>Name la</Typography>
                                    <TextField InputProps={{ readOnly: true }} fullWidth size="small" margin="normal" value={nameLa} required placeholder='Enter Name Laos' />
                                </Box>
                            </Box>
                            <Box sx={{ width: '100%', mt: isSmallScreen ? 1 : 2 }}>
                                <Box>
                                    <Typography>Name en</Typography>
                                    <TextField InputProps={{ readOnly: true }} fullWidth size="small" margin="normal" value={nameEn} required placeholder='Enter Name English' />
                                </Box>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={isSmallScreen ? 12 : 6}>
                        <Typography>Add images (Allowed *.jpeg, *.png Max size of 3.1 MB, size 768×1024)</Typography>
                        <Box
                            mt={isSmallScreen ? 1 : 2}
                            sx={{
                                boxShadow: '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                                width: '100%',
                                height: '80%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                background: '#F4F6F8',
                            }}
                        >
                            <Box>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignContent: 'center',
                                        alignItems: 'center',
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            background: '#EBEBEB',
                                            width: isSmallScreen ? 100 : 150,
                                            height: isSmallScreen ? 100 : 150,
                                            borderRadius: "10px",
                                            cursor: 'pointer',
                                        }}
                                    >
                                        {imageUrl ? (
                                            <img src={imageUrl} style={{ width: isSmallScreen ? 100 : 200, height: isSmallScreen ? 100 : 200, borderRadius: '10px' }} alt='' />
                                        ) : (
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <AddIcon />
                                                <Typography>No Image</Typography>
                                            </Box>
                                        )}
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
                <Box mt={isSmallScreen ? 4 : 2} sx={{ display: 'flex', justifyContent: isSmallScreen ? 'center' : 'end' }}>
                    <Button
                        variant='outlined'
                        color="error"
                        sx={{ textTransform: 'none', mr: isSmallScreen ? 1 : 2, width: 100 }}
                        onClick={onClose}
                    >
                        Cancel
                    </Button>
                </Box>
            </Box>
        </Dialog>
    )
}
export default ViewDataForm;
